import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-notes',
  templateUrl: 'takeaway-order-notes.html',
})
export class TakeawayOrderNotesPage {

  customer_note: any;
  order: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService) {
    //getIndexByTableuid
    this.takeawayServices.getIndexByTableuid();
    //get customer notes
    this.customer_note = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].notes;
    this.getOrder();
  }

  ionViewDidLoad() {

  }

  async save() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //Actualizamos el comentario de la mesa i de la order
    this.takeawayServices.afs.collection('tables').doc(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID).update({
      'notes': this.customer_note,
    }).then(async doc => {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('takeaway-order-note-comentario-guardado'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    });

    if (this.order) {
      this.takeawayServices.afs.collection('orders').doc(this.order.UID).update({
        'notes': this.customer_note,
      });
    }
  }

  async getOrder() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //Obtenemos la order actual
    await this.takeawayServices.getOrders(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);
    this.takeawayServices.orders.subscribe(doc => {
      this.order = doc[0];
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-notes/takeaway-order-notes.ts